const image = document.querySelector('.hero__image')
const imageHomepage = document.querySelector('.hero-homepage__fade')
const hero = document.querySelector('.hero')
    || document.querySelector('.hero-homepage')
const content = hero
    ? hero.nextElementSibling
    : null

const setHeroOpacity = () => {
    if (!content)
        return

    if (window.innerWidth <= 860) {
        if (image && image.style.opacity !== '1')
            image.style.opacity = 1

        if (imageHomepage && imageHomepage.style.opacity !== '1')
            imageHomepage.style.opacity = 1

        return
    }

    const rect = content.getBoundingClientRect()

    if (rect.top > 0) {
        if (image) {
            const multiplier = rect.top / (window.innerHeight * 0.7)

            if (window.innerWidth > 860)
                image.style.opacity = multiplier > 1
                    ? 1
                    : multiplier
        }

        if (imageHomepage) {
            const multiplier = rect.top / (window.innerHeight * 0.8)

            if (window.innerWidth > 860)
                imageHomepage.style.opacity = multiplier > 1
                    ? 1
                    : multiplier
        }
    }
    else if (window.innerWidth > 860) {
        if (image)
            image.style.opacity = 0

        if (imageHomepage)
            imageHomepage.style.opacity = 0
    }
}

const setHeroImageSize = () => {
    if (!hero || !image)
        return

    const contentOffset = document.querySelector('main')
        ? parseInt(window.getComputedStyle(
            document.querySelector('main')).paddingTop || '0')
        : 0

    const breadcrumbs = document.querySelector('.breadcrumbs__transparent')
        || { clientHeight: 0 }

    const videoOffset = document.querySelector('.content__video-first')
        ? 50
        : 0

    if (content.clientWidth === window.innerWidth
            && image.clientHeight !== contentOffset
                + hero.clientHeight + breadcrumbs.clientHeight + videoOffset)
        image.style.height = `${contentOffset
            + hero.clientHeight
            + breadcrumbs.clientHeight
            + videoOffset}px`

    if (content.clientWidth !== window.innerWidth
            && image.style.height)
        image.style.height = ''
}

const setHeroStyles = () => {
    setHeroOpacity()
    setHeroImageSize()
}

if (content
        && (image || imageHomepage)) {
    window.addEventListener('scroll', setHeroOpacity)
    window.addEventListener('resize', setHeroStyles)

    setHeroStyles()
}
